export function is_non_empty_array(x) {
  return Array.isArray(x) && x.length > 0;
}
